import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpContentType, HttpHeaders, HttpMethod } from "../../../common/api/http";
import { EntityIdObject, EntityObject, TwoLevelEntityIdObject } from "../../../common/types";
import { AttachmentConf, CalcSettings, CalcSettingsRequest, CreateCalcSettings, UpdateCalcSettings } from "./types";

const LIST_CALC_SETTINGS = ApiRequestAdapter.create("/calculators/settings", HttpMethod.GET);
const GET_CALC_SETTINGS = ApiRequestAdapter.create("/calculators/settings/{0}", HttpMethod.GET);
const CREATE_CALC_SETTINGS = ApiRequestAdapter.create("/calculators/settings", HttpMethod.POST);
const UPDATE_CALC_SETTINGS = ApiRequestAdapter.create("/calculators/settings/{0}", HttpMethod.PUT);
const DELETE_CALC_SETTINGS = ApiRequestAdapter.create("/calculators/settings/{0}", HttpMethod.DELETE);
const UPLOAD_ATTACHMENT_CONFS = ApiRequestAdapter.create("/calculators/settings/{0}/attachment-confs", HttpMethod.POST);
const DOWNLOAD_ATTACHMENT_CONF = ApiRequestAdapter.create(
  "/calculators/settings/{0}/attachment-confs/{1}",
  HttpMethod.GET,
);
const DELETE_ATTACHMENT_CONF = ApiRequestAdapter.create(
  "/calculators/settings/{0}/attachment-confs/{1}",
  HttpMethod.DELETE,
);

export const calcSettingsApi = {
  listCalcSettings: (request: CalcSettingsRequest): AxiosPromise<CalcSettings[]> => {
    return apiService.get(LIST_CALC_SETTINGS.url, { params: request });
  },
  getCalcSettings: (request: EntityIdObject): AxiosPromise<CalcSettings> => {
    return apiService.get(GET_CALC_SETTINGS.getParametrizedUrl(request.id));
  },
  createCalcSettings: (request: CreateCalcSettings): AxiosPromise<CalcSettings> => {
    return apiService.post(CREATE_CALC_SETTINGS.url, request);
  },
  updateCalcSettings: (request: EntityObject<UpdateCalcSettings>): AxiosPromise<CalcSettings> => {
    return apiService.put(UPDATE_CALC_SETTINGS.getParametrizedUrl(request.id), request.object);
  },
  deleteCalcSettings: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_CALC_SETTINGS.getParametrizedUrl(request.id));
  },
  uploadAttachmentConfs: (request: EntityObject<FormData>): AxiosPromise<AttachmentConf[]> => {
    return apiService.post(UPLOAD_ATTACHMENT_CONFS.getParametrizedUrl(request.id), request.object, {
      headers: { [HttpHeaders.CONTENT_TYPE]: HttpContentType.MULTIPART_FORM_DATA },
    });
  },
  downloadAttachmentConf: (request: TwoLevelEntityIdObject): AxiosPromise<Blob> => {
    return apiService.get(DOWNLOAD_ATTACHMENT_CONF.getParametrizedUrl(request.id1, request.id2), {
      responseType: "blob",
    });
  },
  deleteAttachmentConf: (request: TwoLevelEntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_ATTACHMENT_CONF.getParametrizedUrl(request.id1, request.id2));
  },
};
